import { Button, Drawer, Form, Input, message } from 'antd';
import {
  CREATE_ERROR,
  EDIT_ERROR,
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import { useEffect } from 'react';
import { GSVSService } from 'services/GSVSServise';
import { requiredRule } from 'utils/forms/validationRules';

function GSVSForm({ isActive, onClose, onSuccess, initialValues }) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;
  useEffect(() => {
    if (initialValues) {
      const { kpved_code, tnved_code, name } = initialValues;

      form.setFieldsValue({ kpved_code, tnved_code, name });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  //   TODO: make date by this format YYYY-MM-DD backend help
  const handleSubmit = (values) => {
    const payload = {
      ...values,
    };

    if (isEditing) {
      handleUpdate(payload, initialValues.id);
    } else {
      handleCreate(payload);
    }
  };

  const handleCreate = async (data) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      await GSVSService.createGSVS(data);

      handleConfirm();
      message.success(SUCCESS_CREATE);
    } catch (err) {
      message.error(CREATE_ERROR);
    } finally {
      hide();
    }
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isUpdated = await GSVSService.editGSVS(data, id);

      if (isUpdated) {
        handleConfirm();
        message.success(SUCCESS_UPDATE);
      }
    } catch (err) {
      message.error(EDIT_ERROR);
    } finally {
      hide();
    }
  };

  const handleConfirm = () => {
    onClose();
    onSuccess();
    form.resetFields();
  };

  return (
    <Drawer
      title={isEditing ? 'Редактирование ГСВС' : 'Создание ГСВС'}
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="kpved_code" label="КНВЕД" rules={[requiredRule]}>
          <Input
            controls={false}
            placeholder="Введите КНВЕД"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item name="tnved_code" label="ТНВЕД" rules={[requiredRule]}>
          <Input
            controls={false}
            placeholder="Введите ТНВЕД"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item name="name" label="Название" rules={[requiredRule]}>
          <Input
            controls={false}
            placeholder="Введите название"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { GSVSForm };
